import { NullableBooleanInput as RaNullableBooleanInput } from 'react-admin';
import { styled } from '@mui/material';

const NullableBooleanInput = styled(RaNullableBooleanInput)({
  minWidth: '14.5rem',
});

export default NullableBooleanInput;
